import React from 'react';
import { Link } from '@inertiajs/react';
import { Card, Button } from 'react-bootstrap';
import iconValuation from '../../../images/icon_valuation.png';
import Valuation from '../../Data/Valuation';

interface Props {
	inProgressValuation?: Valuation;
}

const ValuationCtaCard = ({ inProgressValuation }: Props) => {
	const hasStarted = !!inProgressValuation?.user_started_at;

	return (
		<Card>
			<Card.Body className='text-center d-flex flex-column align-items-center justify-content-center px-7 py-9'>
				<img
					src={iconValuation}
					alt='Valuation'
					className='mb-4'
					style={{ width: '54px' }}
				/>
				<div className='mb-5'>
					{inProgressValuation ? (
						<Button
							as={Link as any}
							href={`/valuation-form/${inProgressValuation.id}/basics`}
							variant='primary'
							className='px-7'
						>
							{hasStarted ? 'Continue Your Valuation' : 'Begin Your Valuation'}
						</Button>
					) : (
						<Button
							as='a'
							href='https://iavaluations.com/contact/'
							target='_blank'
							variant='primary'
							className='px-7'
						>
							Begin Your Valuation
						</Button>
					)}
				</div>
				<p className='text-muted small mb-0' style={{ maxWidth: '85%' }}>
					{inProgressValuation ? (
						hasStarted ? (
							<>
								You have a valuation in progress
								(effective date:{' '}
								{new Date(inProgressValuation.effective_date).toLocaleDateString('en-US', { timeZone: 'UTC' })}).
								Pick up where you left off — your
								progress has been saved automatically.
							</>
						) : (
							<>
								Your valuation is ready to begin
								(effective date:{' '}
								{new Date(inProgressValuation.effective_date).toLocaleDateString('en-US', { timeZone: 'UTC' })}).
								Your progress is automatically saved as you fill
								out the form, so you can return anytime.
							</>
						)
					) : (
						<>
							Start a new valuation. Your progress is
							automatically saved as you fill out the
							form, so you can return anytime. Once
							you submit your valuation, the form will
							be locked and any additional changes
							must be submitted via email to your
							valuation agent.
						</>
					)}
				</p>
			</Card.Body>
		</Card>
	);
};

export default ValuationCtaCard;
